import GuestSidebar from '@fiverr-private/sidebar/entries/Guest';

export default GuestSidebar;
